import { useEffect, useMemo } from 'react';
import { InnerBlocks, BlockControls } from '@wordpress/block-editor';
import { ToolbarGroup, ToolbarButton, Icon } from '@wordpress/components';
import { useDispatch, useSelect } from '@wordpress/data';
import { FcUndo, FcRedo } from 'react-icons/fc';
import { symbolFilled } from '@wordpress/icons';
import {boxShadow,VayuBlocksCssborderFrame,background,VayuBlocksUniqueId} from '@vayu-blocks/global';
import { VayuBlocksDevice } from '@vayu-blocks/device-control';
import PanelSettings from './advance/inspector-control';
import AdvanceSettings from './advance';

const edit = ({ attributes, setAttributes, isSelected, clientId }) => {
	const view = VayuBlocksDevice();
	const dispatch = useDispatch();

	VayuBlocksUniqueId({ setAttributes, clientId });

	const parentBlock = useSelect(
		isSelected
			? (select) => {
				const { getBlockParents, getBlock } = select('core/block-editor');
				const parentIds = getBlockParents(clientId, true);
				return parentIds.length ? getBlock(parentIds[0]) : null;
			}
			: () => null,
		[clientId, isSelected]
	);

	useEffect(() => {
		if (!attributes.parentBlock && parentBlock?.name && isSelected) {
			setAttributes({ parentBlock: parentBlock.name });
		}
	}, [isSelected, attributes.parentBlock, parentBlock?.name]);

	// Get the currently selected block
    const selectedBlock = useSelect(isSelected? (select) => select('core/block-editor').getSelectedBlock(): () => null,[isSelected]);

	const flip_wrapper_template = useMemo(() => [
		[
            'vayu-blocks/advance-heading',
            {
                content: 'Title...',
                align: { Desktop: 'center', Tablet: 'center', Mobile: 'center' },
            },
        ],
        [
            'vayu-blocks/advance-button',
            {
                buttonbackgroundColor: '#4e75ff',
                buttonbackgroundColorHvr: '#2F3DA3',
                align: 'center',
                alignment:{Desktop:"center", Tablet:"center", Mobile:"center"}
            },
        ],
	], []);

	// Toggle selection between flip/front/back blocks
	const handleToggleChange = (viewTarget) => {
		if (!selectedBlock || !parentBlock) return;

		const { clientId: parentId, name, innerBlocks = [] } = parentBlock;

		if (viewTarget === 'flip' && name === 'vayu-blocks/flip-box') {
			dispatch('core/block-editor').selectBlock(parentId);
		} else if (viewTarget === 'front' && innerBlocks[0]) {
			dispatch('core/block-editor').selectBlock(innerBlocks[0].clientId);
		} else if (viewTarget === 'back' && innerBlocks[1]) {
			dispatch('core/block-editor').selectBlock(innerBlocks[1].clientId);
		}
	};

	// Dynamic styling
	const mystyle = useMemo(() => ({
			...VayuBlocksCssborderFrame(attributes.frameData, view),
			...boxShadow(attributes.boxShadow, view),
			...background(attributes.flipBackground),
			height: `${attributes.heightwrapper}px` || 'auto',
			display: 'grid',
			alignItems: 'center',
		}),
		[attributes.frameData, attributes.boxShadow, attributes.flipBackground, attributes.heightwrapper, view]
	);

	const isFront = attributes.className?.includes('flip-box-front');
	const isBack = attributes.className?.includes('flip-box-back');

	return (
		<>
			{attributes.parentBlock === 'vayu-blocks/flip-box' && (
				<BlockControls>
					<ToolbarGroup>
						<ToolbarButton label="View Box Flip" onClick={() => handleToggleChange('flip')}>
							<Icon icon={symbolFilled} style={{ color: '#6c1bc3', fontSize: '28px' }} />
						</ToolbarButton>

						{!isFront && (
							<ToolbarButton label="View Front" onClick={() => handleToggleChange('front')}>
								<FcUndo style={{ fontSize: '28px' }} />
							</ToolbarButton>
						)}

						{!isBack && (
							<ToolbarButton label="View Back" onClick={() => handleToggleChange('back')}>
								<FcRedo style={{ fontSize: '28px' }} />
							</ToolbarButton>
						)}
					</ToolbarGroup>
				</BlockControls>
			)}

			<PanelSettings
				attributes={attributes}
				setAttributes={setAttributes}
				isSelected={isSelected}
				clientId={clientId}
				handleToggleChange={handleToggleChange}
			/>

			<AdvanceSettings attributes={attributes} setAttributes={setAttributes} >
				<div className="vayu-blocks-front-image-main-container" style={mystyle}>
					<div className="vayu_blocks_front-image-inner">
						<InnerBlocks template={flip_wrapper_template} />
					</div>
				</div>
			</AdvanceSettings>
		</>
	);
};

export default edit;